import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      const errorMsg = this.state.error?.message || 'Error desconocido';
      const errorStack = this.state.errorInfo?.componentStack || '';
      const failedComponent = errorStack.split('\n').find(l => l.trim().startsWith('at '))?.trim() || '';

      return (
        <div className="flex flex-col items-center justify-center min-h-[400px] gap-4 p-8">
          <AlertTriangle className="w-12 h-12 text-amber-400" />
          <h2 className="text-lg font-semibold text-gray-700">Error al cargar esta seccion</h2>
          <p className="text-sm text-gray-500 text-center max-w-md">
            Ocurrio un error inesperado. Esto puede deberse a una consulta pesada o un problema temporal.
          </p>
          {errorMsg && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-3 max-w-lg w-full">
              <p className="text-xs font-mono text-red-700 break-all">{errorMsg}</p>
              {failedComponent && (
                <p className="text-xs font-mono text-red-500 mt-1">{failedComponent}</p>
              )}
            </div>
          )}
          <div className="flex gap-2 mt-2">
            <Button
              onClick={() => {
                this.setState({ hasError: false, error: null, errorInfo: null });
                window.location.reload();
              }}
            >
              <RefreshCw className="w-4 h-4 mr-2" />
              Recargar Pagina
            </Button>
            <Button variant="outline"
              onClick={() => {
                this.setState({ hasError: false, error: null, errorInfo: null });
              }}
            >
              Intentar de Nuevo
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
